document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        window.FoxThemeCartHelpers.updateCartCount = async () => {
            let cart = await window.FoxThemeCartHelpers.getState();
            cart = BOLD.common.cartDoctor.fix(cart);
            const e = document.querySelectorAll("[data-cart-count-number]");
            e && e.forEach((e => {
                const i = e.closest("[data-cart-count-bubble]");
                const n = e.dataset.type;
                if (n == "drawer")
                    e.textContent = cart.item_count;
                else if (cart.item_count < 100)
                    e.textContent = cart.item_count;
                else
                    e.textContent = "99+";
                if (cart.item_count === 0)
                    i.classList.add("is-cart-empty");
                else
                    i.classList.remove("is-cart-empty")
            }
            ))
        }
    }
})